import { useFilterVehicleContext } from "./filter-vehicle.context";

export function FilterVehicle() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterVehicleContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}